"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldsSettings = void 0;
var utils_1 = require("../../../base-utils/utils");
var common_1 = require("@devexpress/utils/lib/utils/common");
var FieldsSettings = (function () {
    function FieldsSettings() {
        this.openHyperlinkOnClick = false;
        this.updateFieldsBeforePrint = true;
        this.updateFieldsOnPaste = true;
        this.defaultTimeFormat = FieldsSettings.DEFAULT_TIME_FORMAT;
        this.defaultDateFormat = FieldsSettings.DEFAULT_DATE_FORMAT;
        this.openHyperlinkOnClick = false;
        this.keepHyperlinkResultForInvalidReference = false;
        this.createHyperlinkTooltip = function (hyperlinkTooltip, hint) {
            return "" + hyperlinkTooltip + hint;
        };
    }
    ;
    FieldsSettings.prototype.copyFrom = function (obj) {
        if (common_1.isDefined(obj.updateFieldsBeforePrint))
            this.updateFieldsBeforePrint = obj.updateFieldsBeforePrint;
        if (common_1.isDefined(obj.updateFieldsOnPaste))
            this.updateFieldsOnPaste = obj.updateFieldsOnPaste;
        if (common_1.isNonNullString(obj.defaultTimeFormat))
            this.defaultTimeFormat = obj.defaultTimeFormat;
        if (common_1.isNonNullString(obj.defaultDateFormat))
            this.defaultDateFormat = obj.defaultDateFormat;
        if (common_1.isDefined(obj.openHyperlinkOnClick))
            this.openHyperlinkOnClick = obj.openHyperlinkOnClick;
        if (common_1.isDefined(obj.keepHyperlinkResultForInvalidReference))
            this.keepHyperlinkResultForInvalidReference = obj.keepHyperlinkResultForInvalidReference;
        if (common_1.isDefined(obj.createHyperlinkTooltip) && obj.createHyperlinkTooltip !== '')
            this.createHyperlinkTooltip = utils_1.convertToFunction(obj.createHyperlinkTooltip);
    };
    FieldsSettings.prototype.clone = function () {
        var result = new FieldsSettings();
        result.copyFrom(this);
        return result;
    };
    FieldsSettings.DEFAULT_TIME_FORMAT = 'h:mm am/pm';
    FieldsSettings.DEFAULT_DATE_FORMAT = 'M/d/yyyy';
    return FieldsSettings;
}());
exports.FieldsSettings = FieldsSettings;
